import { Trans } from 'react-i18next';

type Props = {
  page: number;
  perPage: number;
  totalCount: number | string;
  size: 'sm' | 'md';
};

const TextResult = ({ page, perPage, totalCount, size }: Props) => (
  <p
    className={`whitespace-nowrap ${
      size === 'sm' ? 'text-xs' : 'text-sm'
    } text-muted-foreground`}
  >
    <Trans
      ns="misc"
      i18nKey="pagination.showing"
      values={{
        from: (page - 1) * perPage + 1,
        to: Math.min(page * perPage, Number(totalCount)),
        total: totalCount ?? 0,
      }}
      components={{ bold: <span className="font-semibold text-foreground" /> }}
    />
  </p>
);

export default TextResult;
